/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Kids Home API
 * Gamified family chore / habit / allowance API
 * OpenAPI spec version: 1.0.0
 */

export type HouseholdHoldResponseTargetKind =
  (typeof HouseholdHoldResponseTargetKind)[keyof typeof HouseholdHoldResponseTargetKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HouseholdHoldResponseTargetKind = {
  reward: 'reward',
  category: 'category',
} as const;
